export default __webpack_public_path__ + "static/media/4.2c7c0da9.jpg";